import useTranslate from '../useTranslate';
import React, { useMemo } from 'react';

interface Props {
    hide?: boolean;
    errors: string[] | undefined;
    standardText?: string;
}

function PbCardErrorElement(props: Readonly<Props>) {
    const strings = useTranslate('SharedErrors');

    const elements = useMemo(() => {
        if (!props.errors) {
            return [];
        }
        const knownErrors = props.errors.map((it) =>
            strings[it] ? (
                <div key={it} className="alert alert-danger">
                    {strings[it]}
                </div>
            ) : null
        );
        return [
            <div key="UNKNOWN" className="alert alert-danger">
                {props.standardText ?? strings.UNKNOWN}
            </div>,
            ...knownErrors,
        ];
    }, [props.errors, props.standardText]);

    if (props.hide) {
        return null;
    } else {
        return elements;
    }
}

export default PbCardErrorElement;
